import styled from "styled-components"
import { H1 } from "../ui"

export const TestimonialsBody = styled.div``

export const TestimonialsHeader = styled(H1)`
  margin-top: 32px;
  text-align: center;
`
